import { useTable } from '@utils/table';

const useTableBlock = () => {
  const tableContainer = document.querySelector(".table-container") as HTMLElement;
  const tableElement = tableContainer.querySelector("table") as HTMLElement;
  const tableScrollContainer = tableContainer.querySelector(".table-container__scroll-container") as HTMLElement;

  const {initTableGradient} = useTable(
    tableContainer,
    tableScrollContainer,
    tableElement,
  );
  
  initTableGradient();
}

useTableBlock();